import React from "react";

import Dropzone from "react-dropzone";
import { useTranslation } from "react-i18next";

import delete_file_disabled from "assets/hearingDetails/delete_disable.svg";
import delete_file from "assets/hearingDetails/delete_file.svg";

import { IAttachmentChildrenModal } from "./interface";
import {
  ClickLocationText,
  ContainerDelete,
  ContainerDivDropzone,
  DropFileContainer,
  DropFileInput,
  DropLocationText,
  FileTitle,
  SizeText,
} from "./styles";

export const DragAndDrop: React.FC<IAttachmentChildrenModal> = (props) => {
  const { t } = useTranslation();

  return (
    <DropFileContainer error={props.fileError && !props.file}>
      {props.file || props.isEdit ? (
        <>
          <FileTitle>
            {props.isEdit ? `${props.file.name}` : props.file.name}
          </FileTitle>
          <SizeText>
            {(props.isEdit ? props.editItem.size : props.file.size) /
              (1024 * 1024) >=
            1
              ? props.isEdit
                ? props.formatFileSize(props.editItem.size)
                : props.formatFileSize(props.file.size)
              : props.isEdit
                ? props.formatFileSize(props.editItem.size)
                : props.formatFileSize(props.file.size)}
          </SizeText>
          <ContainerDelete
            disabled={props.isEdit}
            onClick={() => props.setFile(null)}
          >
            <img
              src={props.isEdit ? delete_file_disabled : delete_file}
              alt=""
            />
          </ContainerDelete>
        </>
      ) : (
        <Dropzone
          accept={props.typeSelected}
          disabled={!props.type}
          onDrop={props.onDrop}
          onDropRejected={props.onDropRejected}
          maxSize={props.maxSize}
          multiple={props.multiple}
        >
          {({ getRootProps, getInputProps, isDragActive }) => (
            <ContainerDivDropzone
              {...getRootProps()}
              isDragActive={isDragActive}
              error={props.fileError}
            >
              {isDragActive ? (
                <ClickLocationText>{t("attachments.dropHere")}</ClickLocationText>
              ) : (
                <>
                  <DropLocationText>
                    {!props.type
                      ? t("attachments.selectFile")
                      : t("attachments.dropFileHereOr")}
                  </DropLocationText>
                  <ClickLocationText disabled={!props.type}>
                    {t("attachments.clickToLocate")}
                  </ClickLocationText>
                </>
              )}
              <DropFileInput {...getInputProps()} />
            </ContainerDivDropzone>
          )}
        </Dropzone>
      )}
    </DropFileContainer>
  );
};
